package addedittravelagent

import com.essntl.features.file.domain.model.FileModel
import com.essntl.features.travelagent.domain.model.TravelAgentModel
import com.mohamedrejeb.calf.core.PlatformContext

sealed interface AddEditTravelAgentEvent {
    data class UpdateTravelAgentFields(
        val travelAgent: TravelAgentModel,
    ) : AddEditTravelAgentEvent

    data class AddTravelAgent(val context: PlatformContext) : AddEditTravelAgentEvent

    data class EditTravelAgent(val context: PlatformContext) : AddEditTravelAgentEvent

    data class GetTravelAgent(
        val travelAgentId: String,
    ) : AddEditTravelAgentEvent

    data object ClearSuccessState : AddEditTravelAgentEvent
    data object ClearTravelAgentState : AddEditTravelAgentEvent
    data class AddLogo(val file: FileModel) : AddEditTravelAgentEvent
    data object DeleteLogo : AddEditTravelAgentEvent
}